import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { Point } from "pixi.js";
export class GameReelWildParticleProperties extends AbstractViewProperties {
    constructor() {
        super(...arguments);
        this.emitterProperties = {
            autoUpdate: true,
            frequency: 0.001,
            maxParticles: 1000,
            pos: {
                x: 0,
                y: 0,
            },
            lifetime: {
                min: 0.5,
                max: 0.65
            },
            addAtBack: true,
            behaviors: [
                {
                    type: "spawnShape",
                    config: {
                        type: "polygonalChain",
                        data: GameReelWildParticleProperties.createSpawnZone(new Point(18, 17), 695, 849, 697),
                    }
                },
                {
                    type: "scale",
                    config: {
                        scale: {
                            list: [{ value: 0, time: 0 }, { value: 0.25, time: 0.05 }, { value: 0, time: 1 }],
                            isStepped: false
                        },
                        minMult: 0.1
                    }
                },
                {
                    type: "textureRandom",
                    config: {
                        textures: [
                            "Game-Particle"
                        ]
                    }
                },
                {
                    type: "rotationStatic",
                    config: {
                        min: 0,
                        max: 360,
                    }
                },
                {
                    type: "moveAcceleration",
                    config: {
                        accel: {
                            x: 0,
                            y: 0,
                        },
                        minStart: 0,
                        maxStart: 30,
                        rotate: true,
                    }
                },
            ]
        };
    }
    static createSpawnZone(padding, width, height, midLineHeight) {
        return [
            [
                { x: padding.x, y: padding.y },
                { x: padding.x + width, y: padding.y },
                { x: padding.x + width, y: padding.y + height },
                { x: padding.x, y: padding.y + height },
                { x: padding.x, y: padding.y }
            ],
            //Include these lines below for the reel to also be separated
            [
                { x: padding.x, y: padding.y + midLineHeight },
                { x: padding.x + width, y: padding.y + midLineHeight }
            ]
        ];
    }
}
//# sourceMappingURL=GameReelWildParticlesProperties.js.map